import {CSSProperties} from "react";
import {alpha, Theme} from "@mui/material/styles";
import {lessons} from "../../proto/compiled";

// Distinct from the good / bad / note callouts (green / red / blue)
const THEORY_COLOR = '#7e57c2';

export const textBlockStyleColor = (
  style: lessons.TextBlockStyle | null | undefined,
  theme: Theme,
): string | undefined => {
  switch (style) {
  case lessons.TextBlockStyle.TEXT_STYLE_GOOD_EMPHASIS:
    return theme.palette.success.main;
  case lessons.TextBlockStyle.TEXT_STYLE_BAD_EMPHASIS:
    return theme.palette.error.main;
  case lessons.TextBlockStyle.TEXT_STYLE_EMPHASIS:
    return theme.palette.info.main;
  case lessons.TextBlockStyle.TEXT_STYLE_THEORY:
    return THEORY_COLOR;
  default:
    return undefined;
  }
};

export const textBlockStyleProps = (
  style: lessons.TextBlockStyle | null | undefined,
  theme: Theme,
): CSSProperties => {
  const color = textBlockStyleColor(style, theme);
  if (!color) return {};
  return {
    backgroundColor: alpha(color, 0.08),
    borderLeft: `4px solid ${color}`,
  };
};
